import { Color3 } from "@babylonjs/core/Maths/math.color";
import { Vector2, Vector3 } from "@babylonjs/core/Maths/math.vector";
import { Curve3 } from "@babylonjs/core/Maths/math.path";
import { CreateCylinder } from "@babylonjs/core/Meshes/Builders/cylinderBuilder";
import { CsgUtils } from "../CsgUtils";
import { ElementGeometry } from "./ElementGeometry";
import { Util } from "../../utils/Util";
import { ShadowGenerator } from "@egr/wcf/modules/core/rendering/ShadowGenerator";
import { PbrMaterial } from '@egr/wcf/modules/core/mdl';
import { PropertyValue, StringProperty, LengthProperty, BoolProperty, NumberProperty, Color3Property, PropertyChangedResult } from '@egr/wcf/modules/core/prop';
import { clamp, eq, degToRad } from '@egr/wcf/modules/utils/math';
import { VECTOR3_Y, VECTOR2_X, signedAngleBetweenVectors2, perpendicularVector2 } from "@egr/wcf/modules/core/utils/MathUtils";
export class Fence extends ElementGeometry {
    constructor(pRoomManager, pElement, pCurved = false) {
        super(pRoomManager, pElement);
        this.mRoomElement = pElement;
        this.mRoomManager = pRoomManager;
        this.mMidPoints = new Array();
        this.mPoints = new Array();
        this.mPointsTMP = new Array();
        this.mCutPoints = new Array();
        this.mSegmentsLength = new Array();
        this.mWidth = 0.015;
        this.mDepth = 0;
        this.mLength = 0;
        this.mHeight = 1;
        this.mMaterial = 0;
        this.mColor = "#999999";
        this.mCenter = Vector3.Zero();
        this.mminPoint = Vector3.Zero();
        this.mmaxPoint = Vector3.Zero();
        this.mArea = 0;
        this.mPerimeter = 0;
        this.mClosedPolygon = false;
        this.mCatMullRom = new Curve3([]);
        this.mSplinePrecision = 12;
        this.mPostsPositions = new Array();
        this.mPostWidth = 0.05;
        this.mFenceThickness = 0.005;
        this.mCirclePointList = new Array();
        this.mStandardMat = new PbrMaterial("", this.mMatManager);
        this.mStandardMat.albedoColor = Color3.FromHexString("#949494");
        this.mStandardMat.unlit = false;
        this.mStandardMat.freeze();
        this.mRoomElement.Params.ElementPoints = new Array();
        this.mRoomElement.Params.ElementOriginalPoints = new Array();
        this.mRoomElement.Params.material = this.mRoomElement.material;
        this.mRoomElement.Params.materialColor = this.getInitialParams().color;
        this.mRoomElement.Params.FenceFieldLength = 1;
        this.mRoomElement.Params.FenceRoundPost = false;
        this.mRoomElement.Params.FenceMirrorTexture = true;
        this.mRoomElement.Params.FencePostMATCategory = "color";
        this.mRoomElement.Params.FencePostMATValue =
            this.mRoomManager._getFirstDefaultextMaterialOfCategory(this.mRoomElement.Params.FencePostMATCategory);
        let tMatId = this.mRoomElement.Params.FencePostMATCategory + this.mRoomManager.materialSplitStr +
            this.mRoomElement.Params.FencePostMATValue;
        this.mRoomManager._loadExternalMaterial(tMatId);
        this.mRoomElement.setHeight(1, false);
        this.createPost_Round();
    }
    getType() {
        return ("Fence");
    }
    setMesh(pMesh) {
        this.mArea = Util.calcMeshArea(pMesh) * 0.25;
    }
    get drawnMesh() {
        return (this.mMesh2d);
    }
    getPoints() {
        return this.mPoints;
    }
    getMidPoints() {
        this.mMidPoints = [];
        for (let i = 0; i < this.mPoints.length - 1; i++) {
            let tmP = Vector3.Center(this.mPoints[i], this.mPoints[i + 1]);
            this.mMidPoints.push(tmP);
        }
        return (this.mMidPoints);
    }
    getSegmentsLength() {
        return (this.mSegmentsLength);
    }
    width() {
        return this.mWidth;
    }
    depth() {
        return this.mDepth;
    }
    material() {
        return this.mMaterial;
    }
    center() {
        return this.mCenter;
    }
    minPoint() {
        return this.mminPoint;
    }
    maxPoint() {
        return this.mmaxPoint;
    }
    showInteractors(pShow) {
        if (this.mInteractors != null)
            this.mInteractors.showInteractors(pShow);
    }
    correctDirection() {
        /*
        let tclosed = BoolProperty.ConvertValueToBool(this.isClosed().value)!;

        if (!tclosed) {
            this.mPoints.push(this.mPoints[0])
        }

        let tClockwise = Util._clockWise(this.mPoints);
        if (tClockwise) {
            this.mPoints.reverse();
            if (!tclosed)
                this.mPoints.shift();
        } else {
            if (!tclosed)
                this.mPoints.pop();
        }
        */
    }
    correctDirection1() {
        for (let tPolygon of this.mCutPoints) {
            let tClockwise = Util._clockWise3(tPolygon);
            if (tClockwise)
                tPolygon.reverse();
        }
    }
    getInitialParams() {
        let tParams = {};
        tParams.width = 0.5;
        tParams.height = 1.0;
        tParams.floorOffset = 0.0;
        tParams.color = this.mColor;
        return (tParams);
    }
    getparent() {
        return (this.mParent);
    }
    get Area() {
        return (this.mArea);
    }
    get Perimeter() {
        return (this.mPerimeter);
    }
    getLines() {
        let tRes = new Array();
        for (let i = 0; i < this.mRoomElement.Params.ElementPoints.length - 1; i++) {
            tRes.push([this.mRoomElement.Params.ElementPoints[i], this.mRoomElement.Params.ElementPoints[i + 1]]);
        }
        return (tRes);
    }
    create2dGeometry(pParent) {
        this.mPostsPositions = [];
        if (this.mRoomElement.height !== this.mHeight) {
            this.mHeight = this.mRoomElement.height;
            this.createPost_Round();
        }
        this.mParent = pParent;
        let tLine = this.createFence(pParent);
        this._createFenceField(pParent, true);
    }
    create3dGeometry(pParent) {
        this.mPostsPositions = [];
        let tLine = this.createFence(pParent);
        this._createFenceField(pParent);
    }
    getPropertyClasses() {
        return (Promise.resolve(this.mRoomManager.PropClasses));
    }
    // tslint:disable-next-line:cyclomatic-complexity
    getProperties() {
        let tProperties = new Array();
        let tYesNoChoices = new Array();
        for (let tYesNo of this.mRoomManager._YesNo)
            tYesNoChoices.push(this.mRoomManager._getYesNoPropValue(tYesNo));
        // field length
        let tDepthProp = new LengthProperty(this.mRoomElement, Fence.PROP_KEY_FIELDLENGTH, this.mRoomManager.resources.propertyFenceFieldLength);
        tDepthProp.class = "fence_field";
        tDepthProp.getValue = () => new PropertyValue(this.mRoomElement.Params.FenceFieldLength);
        tDepthProp.setValue = (pValue) => {
            let tValue = LengthProperty.ConvertValueToNumber(pValue);
            if (tValue != null && this.setFenceFieldLength(tValue))
                return (Promise.resolve(PropertyChangedResult.Value));
            return (Promise.resolve(PropertyChangedResult.Nothing));
        };
        tProperties.push(tDepthProp);
        // closed fence
        let tFenceClosedProp = new BoolProperty(this.mRoomElement, Fence.PROP_KEY_FENCECLOSED, this.mRoomManager.resources.propertyFenceClosedOpen);
        tFenceClosedProp.class = "fence_field";
        tFenceClosedProp.choiceList = true;
        tFenceClosedProp.getChoices = () => Promise.resolve(tYesNoChoices);
        tFenceClosedProp.getValue = () => this.isClosed();
        tFenceClosedProp.setValue = (pValue) => {
            if (pValue != null) {
                this.switchOpenCloseFence(pValue);
                return (Promise.resolve(PropertyChangedResult.Value));
            }
            return (Promise.resolve(PropertyChangedResult.Nothing));
        };
        tFenceClosedProp.visible = true;
        tProperties.push(tFenceClosedProp);
        //round posts
        let tRoundPostsProp = new BoolProperty(this.mRoomElement, Fence.PROP_KEY_ROUNDPOSTS, this.mRoomManager.resources.propertyFenceRoundPosts);
        tRoundPostsProp.class = "fence_posts";
        tRoundPostsProp.choiceList = true;
        tRoundPostsProp.getChoices = () => Promise.resolve(tYesNoChoices);
        tRoundPostsProp.getValue = () => this.mRoomManager._getYesNoPropValue(this.mRoomElement.Params.FenceRoundPost);
        tRoundPostsProp.setValue = (pValue) => {
            if (pValue != null) {
                let tval = BoolProperty.ConvertValueToBool(pValue);
                this.setFenceRoundPosts(tval);
                return (Promise.resolve(PropertyChangedResult.Value));
            }
            return (Promise.resolve(PropertyChangedResult.Nothing));
        };
        tRoundPostsProp.visible = true;
        tProperties.push(tRoundPostsProp);
        //mirror texture
        let tMirrorTextureProp = new BoolProperty(this.mRoomElement, Fence.PROP_KEY_MIRRORTEXTURE, this.mRoomManager.resources.propertyFenceMirrorTexture);
        tMirrorTextureProp.class = "fence_field";
        tMirrorTextureProp.choiceList = true;
        tMirrorTextureProp.getChoices = () => Promise.resolve(tYesNoChoices);
        tMirrorTextureProp.getValue = () => this.mRoomManager._getYesNoPropValue(this.mRoomElement.Params.FenceMirrorTexture);
        tMirrorTextureProp.setValue = (pValue) => {
            if (pValue != null) {
                let tval = BoolProperty.ConvertValueToBool(pValue);
                this.setFenceMirrorTexture(tval);
                return (Promise.resolve(PropertyChangedResult.Value));
            }
            return (Promise.resolve(PropertyChangedResult.Nothing));
        };
        tMirrorTextureProp.visible = true;
        tProperties.push(tMirrorTextureProp);
        // post material: category
        let tMaterialCategory = this.mRoomManager.getMaterial_Categories("fence_post");
        let tMatCatProp = new NumberProperty(this.mRoomElement, Fence.PROP_KEY_POSTSMATCategory, this.mRoomManager.resources.propertyMaterialCategory);
        tMatCatProp.class = "fence_posts";
        tMatCatProp.choiceList = true;
        tMatCatProp.getChoices = () => Promise.resolve(tMaterialCategory);
        tMatCatProp.getValue = () => this.mRoomElement.getMaterialCategoryValue(tMaterialCategory);
        tMatCatProp.setValue = (pValue) => {
            if (pValue != null) {
                this.setPostMaterialCategory(StringProperty.ConvertValueToString(pValue));
                return (Promise.resolve(PropertyChangedResult.Value));
            }
            return (Promise.resolve(PropertyChangedResult.Nothing));
        };
        tMatCatProp.visible = true;
        tProperties.push(tMatCatProp);
        // post material: material
        let tMaterialChoices = new Array();
        this.mRoomManager._getextMaterialOfCategory(this.mRoomElement.Params.FencePostMATCategory, tMaterialChoices, "fence_field");
        if (this.mRoomElement.Params.FencePostMATCategory.trim() === "color") {
            for (let tCol of this.mRoomManager._wallColors)
                tMaterialChoices.push(this.mRoomManager._getWallColorPropValue(tCol));
        }
        if (tMaterialChoices.length > 0) {
            let tcatNamePost = this.mRoomElement.Params.FencePostMATCategory === "color" ?
                this.mRoomManager.resources.propertyColor : this.mRoomManager.resources.propertyMaterial;
            let tMaterialProp = new NumberProperty(this.mRoomElement, Fence.PROP_KEY_POSTSMATValue, tcatNamePost);
            tMaterialProp.class = "fence_posts";
            tMaterialProp.choiceList = true;
            tMaterialProp.getChoices = () => Promise.resolve(tMaterialChoices);
            let tMatId = this.mRoomElement.Params.FencePostMATCategory + this.mRoomManager.materialSplitStr +
                this.mRoomElement.Params.FencePostMATValue;
            if (this.mRoomElement.Params.FencePostMATCategory === "color") {
                tMaterialProp.getValue = () => this.mRoomManager._getWallColorPropValue(this.mRoomElement.Params.FencePostMATValue);
            }
            else {
                tMaterialProp.getValue = () => this.mRoomManager.getMaterialValue(this.mRoomElement.materialSet, tMaterialChoices);
            }
            tMaterialProp.setValue = (pValue) => {
                if (pValue != null) {
                    this.setPostMaterialValue(StringProperty.ConvertValueToString(pValue));
                    return (Promise.resolve(PropertyChangedResult.Value));
                }
                return (Promise.resolve(PropertyChangedResult.Nothing));
            };
            tMaterialProp.visible = true;
            tProperties.push(tMaterialProp);
        }
        // field material: category
        let tType = "fence_field";
        let tField_MaterialCategory = this.mRoomManager.getMaterial_Categories(tType);
        let tField_MaterialCatProp = new NumberProperty(this.mRoomElement, Fence.PROP_KEY_FIELDSMATCategory, this.mRoomManager.resources.propertyMaterialCategory);
        tField_MaterialCatProp.class = "fence_field";
        tField_MaterialCatProp.choiceList = true;
        tField_MaterialCatProp.getChoices = () => Promise.resolve(tField_MaterialCategory);
        tField_MaterialCatProp.getValue = () => this.mRoomElement.getMaterialCategoryValue(tField_MaterialCategory);
        tField_MaterialCatProp.setValue = (pValue) => {
            if (pValue != null) {
                this.mRoomElement.setMaterialCategory(StringProperty.ConvertValueToString(pValue), undefined, undefined, this.mRoomElement.materialSet);
                return (Promise.resolve(PropertyChangedResult.Value));
            }
            return (Promise.resolve(PropertyChangedResult.Nothing));
        };
        tField_MaterialCatProp.visible = true;
        tProperties.push(tField_MaterialCatProp);
        // field material: material
        let tField_MaterialChoices = this.mRoomManager.getMaterialsOfCategory(this.mRoomElement.materialSet, tType);
        let tcatName = this.mRoomElement.materialSet.category === "color" ? this.mRoomManager.resources.propertyColor : this.mRoomManager.resources.propertyMaterial;
        let tField_MaterialProp;
        if (this.mRoomElement.materialSet.category === "color") {
            tField_MaterialProp = new Color3Property(this.mRoomElement, Fence.PROP_KEY_FIELDSMATValue, tcatName);
        }
        else {
            tField_MaterialProp = new StringProperty(this.mRoomElement, Fence.PROP_KEY_FIELDSMATValue, tcatName);
        }
        tField_MaterialProp.class = "fence_field";
        tField_MaterialProp.choiceList = true;
        tField_MaterialProp.getChoices = () => Promise.resolve(tField_MaterialChoices);
        tField_MaterialProp.getValue = () => this.mRoomManager.getMaterialValue(this.mRoomElement.materialSet, tField_MaterialChoices);
        tField_MaterialProp.setValue = (pValue) => {
            let tValue = StringProperty.ConvertValueToString(pValue);
            if (tValue != null) {
                this.mRoomElement.setMaterialValue__(tValue, this.mRoomElement.materialSet, true);
                return (Promise.resolve(PropertyChangedResult.Value));
            }
            return (Promise.resolve(PropertyChangedResult.Nothing));
        };
        tField_MaterialProp.visible = true;
        tProperties.push(tField_MaterialProp);
        return (tProperties);
    }
    serializeIOData() {
        return (this.mRoomElement.Params);
    }
    loadIOData(pData) {
        let tParams = pData;
        let tPoints = new Array();
        for (let tEP of tParams.ElementPoints) {
            let tP = new Vector3(0, 0, 0);
            tP.x = tEP.x;
            tP.z = tEP.z;
            tPoints.push(tP);
        }
        this.mRoomElement.Params.HedgeDepth = tParams.HedgeDepth;
        this.setPoints(tPoints);
    }
    setPoints(pPoints, pCorrectDirection = false) {
        //this.mCutPoints = [];
        this.mPoints = [];
        for (let tPoint of pPoints) {
            let tP = new Vector3(0, 0, 0);
            tP.x = tPoint.x;
            tP.z = tPoint.z;
            this.mPoints.push(tP);
        }
        if (pCorrectDirection)
            this.correctDirection();
        this.mRoomElement.Params.ElementPoints = this.mPoints;
        this.calcCenter();
        this.calcSize();
    }
    deletePoint(pIndex) {
        if (pIndex > this.mPoints.length - 1 || pIndex < 0 || this.mPoints.length === 0 || this.mPoints.length <= 3)
            return;
        this.mPoints.splice(pIndex, 1);
        this.mRoomElement.Params.ElementPoints = this.mPoints;
        this.calcCenter();
        this.calcSize();
    }
    addPoint(pIndex) {
        let tc1 = pIndex - 1;
        let tc2 = pIndex === this.mPoints.length ? 0 : pIndex;
        let tnewPoint = Vector3.Center(this.mPoints[tc1], this.mPoints[tc2]);
        tnewPoint.x += 0.001;
        tnewPoint.z -= 0.001;
        this.mPoints.splice(pIndex, 0, tnewPoint);
        this.mRoomElement.Params.ElementPoints = this.mPoints;
        this.calcCenter();
        this.calcSize();
    }
    setCutPoints(pPoints, pCenter = false) {
        this.mCutPoints = [];
        for (let tarrPoints of pPoints) {
            let tnewPoints = new Array();
            for (let tPoint of tarrPoints) {
                let tP = new Vector3(0, 0, 0);
                tP.x = tPoint.x;
                tP.z = tPoint.z;
                tnewPoints.push(tP);
            }
            this.mCutPoints.push(tnewPoints);
        }
        if (pCenter)
            this.centerPoints(this.mCutPoints);
        this.checkClosedPolygon();
        if (this.mClosedPolygon)
            this.correctDirection1();
    }
    centerPoints(pPoints) {
        this.mCutPoints = [];
        for (let tpointArr of pPoints) {
            let tnewArr = new Array();
            for (let tPoint of tpointArr) {
                let tnP = Util.to3d(Util.to2d(Vector3.TransformCoordinates(tPoint, this.mRoomElement.transformInverted)));
                tnewArr.push(tnP);
            }
            this.mCutPoints.push(tnewArr);
        }
    }
    checkClosedPolygon() {
        if (this.mPoints.length < 3)
            return;
        this.mClosedPolygon = Util.closedPolygon(this.mPoints);
        this.mRoomElement.setClosedPolygon(this.mClosedPolygon);
    }
    isClosed() {
        let tRes = false;
        if (Util.vectorEquals3(this.mPoints[0], this.mPoints[this.mPoints.length - 1], 0.0001))
            tRes = true;
        let tPropText = tRes ? this.mRoomManager.resources.propertyValueYes : this.mRoomManager.resources.propertyValueNo;
        let tValue = new PropertyValue(tRes, tPropText);
        return (tValue);
    }
    switchOpenCloseFence(pValue) {
        let tClosed = BoolProperty.ConvertValueToBool(pValue);
        if (!tClosed) {
            this.mPoints.pop();
        }
        else {
            this.mPoints.push(this.mPoints[0]);
        }
        this.mRoomElement.updateGeometry_GEO();
    }
    calcCenter() {
        let t2dPoints = new Array();
        for (let tP of this.mPoints)
            t2dPoints.push(new Vector2(tP.x, tP.z));
        let tCenter = new Vector3(0, 0, 0);
        if (this.mPoints.length > 2)
            tCenter = Util.getPolygonCentroid(t2dPoints);
        else {
            tCenter = Vector3.Center(this.mPoints[0], this.mPoints[1]);
        }
        this.mCenter = tCenter;
        this.mCenter = Util.getCenterofPolygon(this.mPoints);
    }
    calcSize() {
        let tPoints = this.getPoints();
        if (tPoints.length === 0)
            return;
        let tminX = tPoints[0].x;
        let tminY = tPoints[0].z;
        let tmaxX = tPoints[0].x;
        let tmaxY = tPoints[0].z;
        for (let tPoint of tPoints) {
            tminX = Math.min(tPoint.x, tminX);
            tmaxX = Math.max(tPoint.x, tmaxX);
            tminY = Math.min(tPoint.z, tminY);
            tmaxY = Math.max(tPoint.z, tmaxY);
        }
        this.mWidth = tmaxX - tminX;
        this.mDepth = tmaxY - tminY;
        this.mRoomElement.setWidth(this.mWidth, false, false);
        this.mRoomElement.setDepth(this.mDepth, false, false);
        this.mminPoint = new Vector3(tminX, 0, tminY);
        this.mmaxPoint = new Vector3(tmaxX, 0, tmaxY);
    }
    getSegmentsLength_straight(pPoints) {
        this.mSegmentsLength = [];
        this.mLength = 0;
        for (let x = 0; x < pPoints.length - 1; x++) {
            let tDist = Vector3.Distance(pPoints[x], pPoints[x + 1]);
            this.mSegmentsLength.push(tDist);
            this.mLength += tDist;
        }
        this.mRoomElement.setLength(this.mLength);
    }
    async checkMaterial() {
        let tMatId = this.mRoomElement.Params.FencePostMATCategory +
            this.mRoomManager.materialSplitStr +
            this.mRoomElement.Params.FencePostMATValue;
        await this.mRoomManager._loadExternalMaterial(tMatId);
    }
    setFenceFieldLength(pValue, pUpdateGeometry = true) {
        let tValue = clamp(pValue, 0.5, 5);
        if (eq(this.mRoomElement.Params.FenceFieldLength, tValue))
            return (false);
        this.mRoomElement.Params.FenceFieldLength = tValue;
        if (pUpdateGeometry) {
            this.mRoomElement.updateGeometry_GEO();
        }
        return (true);
    }
    setFenceMirrorTexture(pValue, pUpdateGeometry = true) {
        if (pValue === this.mRoomElement.Params.FenceMirrorTexture)
            return (false);
        this.mRoomElement.Params.FenceMirrorTexture = pValue;
        if (pUpdateGeometry) {
            this.mRoomElement.updateGeometry_GEO();
        }
        return (true);
    }
    setFenceRoundPosts(pValue, pUpdateGeometry = true) {
        if (pValue === this.mRoomElement.Params.FenceRoundPost)
            return (false);
        this.mRoomElement.Params.FenceRoundPost = pValue;
        if (pUpdateGeometry) {
            this.mRoomElement.updateGeometry_GEO();
        }
        return (true);
    }
    async setPostMaterialCategory(pValue, pMatOfCat = "") {
        if (this.mRoomElement.Params.FencePostMATCategory === pValue)
            return (false);
        this.mRoomElement.Params.FencePostMATCategory = pValue;
        this.mRoomElement.Params.FencePostMATValue = pMatOfCat;
        if (this.mRoomElement.Params.FencePostMATValue === "") {
            this.mRoomElement.Params.FencePostMATValue = this.mRoomManager._getFirstDefaultextMaterialOfCategory(pValue);
        }
        if (this.mRoomElement.Params.FencePostMATValue === "" && pValue === "color") {
            this.mRoomElement.Params.FencePostMATValue = this.mColor;
        }
        await this.checkMaterial();
        this.mRoomElement.updateGeometry_GEO();
        return (true);
    }
    async setPostMaterialValue(pValue = "") {
        let tmatGroup = pValue.split(this.mRoomManager.materialSplitStr);
        if (tmatGroup !== undefined) {
            if (tmatGroup.length === 1) {
                this.mRoomElement.Params.FencePostMATValue = tmatGroup[0];
            }
            if (tmatGroup.length > 1) {
                this.mRoomElement.Params.FencePostMATValue = tmatGroup[1];
            }
        }
        else {
            this.mRoomElement.Params.FencePostMATCategory = "color";
            this.mRoomElement.Params.FencePostMATValue = "#999999";
        }
        await this.checkMaterial();
        this.mRoomElement.updateGeometry_GEO();
        return (true);
    }
    createFence(pParent) {
        this.createFencingPosts(pParent);
    }
    createPost_Round() {
        this.mCirclePointList = [];
        let tRadius = this.mPostWidth * 0.5;
        let tCosA;
        let tSinA;
        for (let i = 0; i < 20; i++) {
            let tDeg = degToRad(i * 18.0 - 360);
            tCosA = Math.cos(tDeg);
            tSinA = Math.sin(tDeg);
            this.mCirclePointList.push(new Vector2(tCosA * tRadius - (tRadius * 0.5), tSinA * tRadius - (tRadius * 0.5)));
        }
        this.createPostGeometry_Box();
    }
    getPolygon(pPos, pRound = true) {
        let tpolygonPoints = [];
        let tWH = this.mPostWidth * 0.5;
        let tsplinePoints = new Array();
        if (pRound) {
            tsplinePoints = Util.to3dArray(this.mCirclePointList);
        }
        else {
            tsplinePoints.push(new Vector3(tWH, 0, tWH));
            tsplinePoints.push(new Vector3(-tWH, 0, tWH));
            tsplinePoints.push(new Vector3(-tWH, 0, -tWH));
            tsplinePoints.push(new Vector3(tWH, 0, -tWH));
        }
        for (let tP of tsplinePoints) {
            let tnP = tP.add(pPos);
            tpolygonPoints.push(tnP);
        }
        return (tpolygonPoints);
    }
    createPostGeometry_Box() {
        let tP = this.getPolygon(new Vector3(0, 0, 0), false);
        let tPoints = new Array();
        for (let tPnt of tP) {
            tPoints.push(new CSG.Vector2D(tPnt.x, tPnt.z));
        }
        let tCAGshape = CAG.fromPointsNoCheck(tPoints);
        if (tCAGshape.isSelfIntersecting())
            return;
        let tCSG = Util.CAG2CSG(tCAGshape, this.mRoomElement.height);
        let tMeshes = CsgUtils.buildMeshes(tCSG, this.mScene);
        if (tMeshes == null)
            return;
        if (this.mPost_Box != null) {
            this.mPost_Box.dispose();
            this.mPost_Box = null;
        }
        let tPostMatId = this.mRoomElement.Params.FencePostMATCategory + this.mRoomManager.materialSplitStr +
            this.mRoomElement.Params.FencePostMATValue;
        if (tMeshes.length >= 1) {
            this.mPost_Box = tMeshes[0].clone();
            this.mPost_Box.makeGeometryUnique();
            this.mPost_Box.material = this.mRoomManager.MatManager.getMaterial(tPostMatId);
            this.mPost_Box.visibility = 0;
            this.mPost_Box.parent = this.mRoomElement.node;
            ShadowGenerator.disableMeshShadow(this.mPost_Box);
        }
        for (let tMesh of tMeshes)
            tMesh.dispose();
    }
    createPost(pParent, pPos, pAngle) {
        let tPostMatId = this.mRoomElement.Params.FencePostMATCategory + this.mRoomManager.materialSplitStr +
            this.mRoomElement.Params.FencePostMATValue;
        let options_r = {
            diameter: this.mPostWidth,
            tessellation: 20,
            height: this.mRoomElement.height,
            wrap: true
        };
        if (!this.mRoomElement.Params.FenceRoundPost) {
            if (this.mPost_Box == null) {
                this.createPostGeometry_Box();
            }
            if (this.mPost_Box == null) {
                return;
            }
            let ttmpBox = this.mPost_Box.clone();
            ttmpBox.makeGeometryUnique();
            ttmpBox.name = "fence_post";
            ttmpBox.parent = pParent;
            ttmpBox.material = this.mRoomManager.MatManager.getMaterial(tPostMatId);
            ttmpBox.position = pPos;
            ttmpBox.visibility = 1;
            ttmpBox.rotate(VECTOR3_Y, pAngle * (-1));
        }
        else {
            let tPost = CreateCylinder("", options_r, this.mScene);
            tPost.parent = pParent;
            tPost.name = "fence_post";
            tPost.material = this.mRoomManager.MatManager.getMaterial(tPostMatId);
            tPost.position = pPos;
            tPost.position.y = this.mRoomElement.height * 0.5;
        }
    }
    createFencingPosts(pParent) {
        if (this.mPoints.length < 2)
            return;
        for (let i = 0; i < this.mPoints.length; i++) {
            let tAngle = 0;
            if (i < this.mPoints.length - 1) {
                let tDir = Util.to2d((this.mPoints[i + 1].subtract(this.mPoints[i])).normalize());
                tAngle = signedAngleBetweenVectors2(VECTOR2_X, tDir);
            }
            let tClosed = BoolProperty.ConvertValueToBool(this.isClosed().value);
            if (i === this.mPoints.length - 1) {
                if (!tClosed)
                    this.createPost(pParent, this.mPoints[i].clone(), tAngle);
            }
            else {
                this.createPost(pParent, this.mPoints[i].clone(), tAngle);
            }
            this.getSegmentsLength_straight(this.mRoomElement.Params.ElementPoints);
            if (this.mPostsPositions[i] == null)
                this.mPostsPositions[i] = new Array();
            this.mPostsPositions[i].push(this.mPoints[i]);
            if (i < this.mPoints.length - 1) {
                this.createIntermediatePosts(i, tAngle, pParent);
            }
        }
        if (this.mPost_Box != null) {
            this.mPost_Box.dispose();
            this.mPost_Box = null;
        }
    }
    createIntermediatePosts(pIdx, pAngle, pParent) {
        let tstartPoint = this.mPoints[pIdx].clone();
        let tendPoint = this.mPoints[pIdx + 1].clone();
        let tDistance = Vector3.Distance(tstartPoint, tendPoint);
        let tDirection = (tendPoint.subtract(tstartPoint)).normalize();
        let tFL = this.mRoomElement.Params.FenceFieldLength;
        let tcount = Math.floor((tDistance - this.mPostWidth) / (tFL + this.mPostWidth));
        for (let i = 1; i <= tcount; i++) {
            let tDestP = tDirection.scale((tFL + this.mPostWidth) * i);
            let tSP = tstartPoint.add(tDestP);
            this.mPostsPositions[pIdx].push(tSP);
            this.createPost(pParent, tSP.clone(), pAngle);
        }
        this.mPostsPositions[pIdx].push(this.mPoints[pIdx + 1]);
    }
    _buildFenceField(pParent, pStart, pEnd, p2d = false) {
        let tEdges = new Array();
        let tDist = Vector2.Distance(pStart, pEnd);
        let tDir = pEnd.subtract(pStart).normalize();
        let tDirRight = perpendicularVector2(tDir);
        let tDirLeft = Util.invert2d(tDirRight);
        let tP0 = pStart.add(tDirRight.scale(this.mFenceThickness * 0.5));
        let tP1 = tP0.add(tDir.scale(tDist));
        let tP3 = pStart.add(tDirLeft.scale(this.mFenceThickness * 0.5));
        let tP2 = tP3.add(tDir.scale(tDist));
        tEdges.push(tP2, tP3, tP0, tP1);
        let tCSG = null;
        let tMat = this.mRoomElement.localMaterial;
        if (tMat != null)
            tMat.backFaceCulling = false;
        if (p2d) {
            tMat = this.mRoomManager.MatManager.getMaterial("color_-_#999999");
        }
        if (tMat != null) {
            tMat.backFaceCulling = false;
            tCSG = CsgUtils.extrudeFence(tEdges, this.mRoomElement.height, tMat, this.mRoomElement.Params.FenceMirrorTexture, p2d);
        }
        if (tCSG == null)
            return;
        tCSG = tCSG.reTesselated().canonicalized();
        //create meshes
        let tMeshes = CsgUtils.buildMeshes(tCSG, this.mScene);
        if (tMeshes != null) {
            for (let tMesh of tMeshes) {
                tMesh = Util.generatePlaneUVS(tMesh);
                if (tMesh.material == null) {
                    tMesh.material = this.mRoomManager.wallDefaultMaterial;
                }
                if (p2d) {
                    this.prepare2dMesh(tMesh);
                }
                tMesh.name = "fence_field";
                tMesh.parent = pParent;
                tMesh.freezeWorldMatrix();
            }
        }
    }
    _separatedFields(pParent, p2d = false) {
        for (let tHP of this.mPostsPositions) {
            if (tHP.length < 2)
                continue;
            for (let i = 0; i < tHP.length - 1; i++) {
                let tSP = Util.to2d(tHP[i].clone());
                let tEP = Util.to2d(tHP[i + 1].clone());
                let tDir = tEP.subtract(tSP).normalize();
                tSP.addInPlace(tDir.scale(this.mPostWidth * 0.5));
                tEP.subtractInPlace(tDir.scale(this.mPostWidth * 0.5));
                let tDist = Vector2.Distance(tSP, tEP);
                if (tDist < 0.01)
                    continue;
                this._buildFenceField(pParent, tSP, tEP, p2d);
            }
        }
    }
    _createFenceField(pParent, p2d = false) {
        if (this.mPoints.length === 0)
            return;
        if (this.mRoomManager.isInteracting) {
            this._separatedFields(pParent, p2d);
        }
        else {
            this._separatedFields(pParent, p2d);
        }
    }
}
//// private ///////////////////////////////////////////////////////////////////////////////
Fence.PROP_KEY_FIELDLENGTH = "room:RoomElement:fieldlength";
Fence.PROP_KEY_FENCECLOSED = "room:RoomElement:fenceClosed";
Fence.PROP_KEY_MIRRORTEXTURE = "room:RoomElement:mirrortexture";
Fence.PROP_KEY_ROUNDPOSTS = "room:RoomElement:roundPosts";
Fence.PROP_KEY_POSTSMATCategory = "room:RoomElement:postMaterialCategory";
Fence.PROP_KEY_POSTSMATValue = "room:RoomElement:postMaterialValue";
Fence.PROP_KEY_FIELDSMATCategory = "room:RoomElement:fieldMaterialCategory";
Fence.PROP_KEY_FIELDSMATValue = "room:RoomElement:fieldMaterialValue";
